import { mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBG_CUSTOM_08_Schema } from './M_TBG_CUSTOM_08_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';

/** 회의 내용 저장 SP_M20907_U1 (Global.urls.TBM.saveTbmBasicU3) */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_08_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.TBM.saveTbmBasicU3, payload);
  }, options);
};

/** TBM 종료시간 업데이트 SP_M20908_U1 (Global.urls.TBM.saveTbmBasicU4) */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_08_Schema.mapper.save2);
    return apiRequest('post1', Global.urls.TBM.saveTbmBasicU4, payload);
  }, options);
};

/** 교육현황 저장 SP_TBM_STATUS_U1 (Global.urls.TBM.saveTbmStatusU1) */
export const useSave3 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_08_Schema.mapper.save3);
    return apiRequest('post1', Global.urls.TBM.saveTbmStatusU1, payload);
  }, options);
};
